import { FeedbackRating } from '../../pages/MyInfo/MyInfoOwnTractorDetailPage/components/FeedbackPopupBody';

// TODO: 추후 시트 관련 구조 정리되면 시트 constants 파일 생성 후 위치 이동
const PRODUCTION_URL =
  'https://script.google.com/macros/s/AKfycbw_NEWZT8s1pgwgFmyYyJQ5ltyBlVsFsZ1P4HEMKEEPltbt-7-LJ7UY4YO1v1Vx0IyH/exec';
const DEVELOPMENT_URL =
  'https://script.google.com/macros/s/AKfycbxoEocQXFLXIR5LaYgq_qKmXr9iuOpMxRRxJnSxPBknId3hAiXpergUylw4IV9Kwt5zJg/exec';

const url = process.env.REACT_APP_CLIENT_ENVIRONMENT === 'production' ? PRODUCTION_URL : DEVELOPMENT_URL;

interface IPostPokeFeedbackRatingToSpreadSheet {
  feebackUserId: string;
  price: number;
  pokeRating: FeedbackRating;
  pokeId: string;
}

export const postPokeFeedbackRatingToSpreadSheet = ({
  feebackUserId,
  price,
  pokeRating,
  pokeId,
}: IPostPokeFeedbackRatingToSpreadSheet) => {
  fetch(url, {
    method: 'POST',
    body: JSON.stringify({
      feebackUserId,
      price,
      pokeRating,
      pokeId,
      path: 'savePokeFeedbackRating',
    }),
  });
};
